export default {
  loginPasswordByUserName: '/auth/loginPasswordByUserName',
  updateUserAuthentication: '/auth/updateUserAuthentication',
  updateUsersAuthInBulk: '/auth/updateUsersAuthInBulk',
  getAllSubAdminOfInstitute: '/auth/getAllSubAdminOfInstitute',
  getUserAuthenticationByUid: '/auth/getUserAuthenticationByUid',
  getUserAuthenticationByUidAndUserName: '/auth/getUserAuthenticationByUidAndUserName',
  getUserAuthenticationsByUIds: '/auth/getUserAuthenticationsByUIds',
}